export const SIGN_TEMPLATE_OPERATORS = [
  { value: "equals", label: "equals" },
  { value: "does_not_equal", label: "does not equal" },
];

export function createDefaultSignTemplateRule() {
  return {
    _key: `sign-rule-${Date.now()}-${Math.random().toString(36).slice(2)}`,
    sf_object: "",
    sf_field_name: "",
    operator: "equals",
    expected_value: "",
    formstack_sign_template_name: "",
    is_active: true,
  };
}

export function mapSignTemplateRulesFromApi(rules = []) {
  return rules.map((rule, idx) => ({
    _key: `sign-rule-${rule.id ?? idx}-${Date.now()}-${idx}`,
    sf_object: rule.sf_object || "",
    sf_field_name: rule.sf_field_name || "",
    operator: rule.operator || "equals",
    expected_value: rule.expected_value ?? "",
    formstack_sign_template_name: rule.formstack_sign_template_name || "",
    is_active: rule.is_active !== false,
  }));
}

export function isSignTemplateRuleRowEmpty(entry) {
  return (
    !entry?.sf_object &&
    !entry?.sf_field_name &&
    !entry?.formstack_sign_template_name &&
    !entry?.expected_value
  );
}

export function validateSignTemplateRules(entries) {
  const errors = [];
  entries.forEach((entry, idx) => {
    if (isSignTemplateRuleRowEmpty(entry)) return;
    const prefix = `Rule ${idx + 1}`;
    if (!entry.sf_object) errors.push(`${prefix}: Data Source is required`);
    if (!entry.sf_field_name) errors.push(`${prefix}: Salesforce Field is required`);
    if (!entry.formstack_sign_template_name) {
      errors.push(`${prefix}: Formstack Sign Template is required`);
    }
    if (!SIGN_TEMPLATE_OPERATORS.some((op) => op.value === entry.operator)) {
      errors.push(`${prefix}: Operator is invalid`);
    }
  });
  return errors;
}

export function buildSignTemplateRulesPayload(entries, defaultName) {
  const rules = entries
    .filter((entry) => !isSignTemplateRuleRowEmpty(entry))
    .map((entry, idx) => ({
      order: idx,
      sf_object: entry.sf_object,
      sf_field_name: entry.sf_field_name,
      operator: entry.operator || "equals",
      expected_value: entry.expected_value ?? "",
      formstack_sign_template_name: entry.formstack_sign_template_name,
      is_active: Boolean(entry.is_active),
    }));

  return {
    default_formstack_sign_template_name: defaultName ?? "",
    rules,
  };
}

export function parseSignTemplateMappingApiErrors(err) {
  const data = err?.response?.data;
  if (Array.isArray(data?.errors) && data.errors.length > 0) {
    return data.errors;
  }
  if (typeof data?.error === "string" && data.error.trim()) {
    return [data.error];
  }
  return ["Failed to save Formstack Sign overlay template mapping."];
}
